<template>
  <GmapMap v-bind="options">
    <GmapInfoWindow
      :options="infoOptions"
      :position="infoWindowPos"
      :opened="infoWinOpen"
      @closeclick="infoWinOpen = false"
    >
    </GmapInfoWindow>
    <GmapMarker
      :key="i"
      v-for="(m, i) in markers"
      :position="m.position"
      :clickable="true"
      @click="toggleInfoWindow(m, i)"
    ></GmapMarker>
  </GmapMap>
</template>
<script>
const mapPosition = { position: { lat: 52.581547, lng: -2.128197 } };
export default {
  data() {
    return {
      options: {
        zoom: 19,
        mapTypeId: "roadmap",
        center: mapPosition.position,
        streetViewControl: true,
      },
      markers: [mapPosition],

      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        content: `<div class="map-marker-content">
        <h5>ZOE ESTATES LTD</h5>
        <p>
        Kings House Business Centre<br/>
        St John's Square<br/>
        WV2 4DT<br/>
        Wolverhampton<br/>
        United Kingdom
        </p>
      </div>`,
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
    };
  },
  methods: {
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position;
      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
  },
};
</script>
<style>
.gm-style img {
  max-width: none !important;
}
</style>
